// Footer.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faInstagram, faXTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons"
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className='footer-container'>
                <div className="footer-section">
                    <div className="grandquiz-info">
                        <img className="logo" src={process.env.PUBLIC_URL + "/logo512.png"} alt="App Icon" />
                        <p>
                            Experience the joy of finding your perfect match with Vihana Matrimony. Connect, discover, and build a beautiful future together!
                            <br /><br />
                            Vihana Matrimony is a product of{' '}
                            <a href="https://www.chellobee.com" target="_blank" rel="noopener noreferrer">
                                Chellobee Technologies LLP
                            </a>
                            , a mobile and web development company dedicated to creating innovative and engaging applications.
                        </p>
                        <div className="footer-badges">
                            <a href='https://play.google.com/store/apps/details?id=com.chellobee.vihanamatrimony' target="_blank" rel="noopener noreferrer"><img src={process.env.PUBLIC_URL + "/images/google-play-badge.svg"} alt="Get it on Google Play" /></a>
                            <a href='https://apps.apple.com/in/app/vihana-matrimony-matchmaking/id6742974280' target="_blank" rel="noopener noreferrer" ><img src={process.env.PUBLIC_URL + "/images/app-store-badge.svg"} alt="Download on the App Store" /></a>
                        </div>
                    </div>
                </div>

                <div className="footer-section">
                    <h4>Quick Links</h4>
                    <ul>
                        <li><a href="/privacy-policy">Privacy Policy</a></li>
                        <li><a href="/terms-and-conditions">Terms and Conditions</a></li>
                        <li><a href="/why-vihana">Why Vihana</a></li>
                        <li><a href="/why-premium">Why Premium</a></li>
                        <li><a href="/faq">FAQ</a></li>
                        <li><a href="/safety-guidelines">Safety Guidelines</a></li>
                    </ul>
                </div>

                <div className="footer-section contact">
                    <h4>Contact</h4>
                    <p>For any enquires and business, please write to us at <a href="mailto:support-vihanamatrimony@chellobee.com">support-vihanamatrimony@chellobee.com</a></p>
                </div>
            </div>

            <div className='footer-section-2'>
                <div className='footer-divider' />
                <div className='footer-social'>
                    <div className="social-icons">
                        <a className='facebook' href="https://facebook.com/GrandQuizChellobee" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faFacebook} /></a>
                        <a className='instagram' href="https://www.instagram.com/grandquiz.chellobee/" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
                        <a className='twitter' href="https://twitter.com/grand_quiz" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faXTwitter} /></a>
                        <a className='youtube' href="https://www.youtube.com/@grandquiz.chellobee" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faYoutube} /></a>
                    </div>
                    <div className="copyright-text">
                        © {new Date().getFullYear()} All Rights Reserved by Chellobee Technologies LLP
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
